import { render } from "./TypeDistributionBar.vue?vue&type=template&id=35903a72&scoped=true"
import script from "./TypeDistributionBar.vue?vue&type=script&lang=js"
export * from "./TypeDistributionBar.vue?vue&type=script&lang=js"

import "./TypeDistributionBar.vue?vue&type=style&index=0&id=35903a72&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35903a72"]])

export default __exports__